import { render, staticRenderFns } from "./channelConstructionPlan.vue?vue&type=template&id=f9245498&scoped=true"
import script from "./channelConstructionPlan.vue?vue&type=script&lang=js"
export * from "./channelConstructionPlan.vue?vue&type=script&lang=js"
import style0 from "./channelConstructionPlan.vue?vue&type=style&index=0&id=f9245498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9245498",
  null
  
)

export default component.exports